export default __webpack_public_path__ + "static/11-bd14eb0a0381ef1f3f025f118752689b.jpg";